import { getQuestionList, getProductQuestions } from 'Store/Question/Question.action';
import { fetchMutation, fetchQuery } from 'Util/Request';
import { showNotification } from 'Store/Notification/Notification.action';
import QuestionQuery from 'Query/Question.query';

export class QuestionDispatcher {
    requestQuestions(dispatch, customer_email) {
        const query = QuestionQuery.getQuestionListQuery(customer_email);

        return fetchQuery(query).then(
            ({ questions }) => { dispatch(getQuestionList(questions, false)); },
            (error) => {
                dispatch(showNotification('error', error[0].message));
            }
        );
    }

    submitProductQuestion(dispatch, fields) {
        const questionItem = fields;

        return fetchMutation(QuestionQuery.getAddProductQuestionMutation(
            questionItem
        )).then(
            () => dispatch(showNotification( 'success', __('Thank you for your interest! The question has been logged in our system. We will answer as soon as possible.') )),
            // eslint-disable-next-line no-console
            error => dispatch(showNotification('error', 'Error submitting your question!')) && console.log(error)
        );
    }

    requestProductQuestions(dispatch, id, page) {
        const query = QuestionQuery.getProductQuestionsQuery(id, page);

        return fetchQuery(query).then(
            ({ questions }) => { dispatch(getProductQuestions(questions, false)); },
            (error) => {
                dispatch(showNotification('error', error[0].message));
            }
        );
    }
}

export default new QuestionDispatcher();
